<template>
	<a-dropdown
		:trigger="actions ? ['click'] : []"
		:class="actions ? 'pointer' : ''"
	>
		<a-tag
			v-if="data.FacturaEstado===0"
			:color="$colors.warning"
		>
			<fa-icon
				:icon="['fas','clock']"
				class="mr-2"
			/>
			Pendiente
			<a-icon
				v-if="actions"
				type="down"
			/>
		</a-tag>
		<a-tag
			v-else-if="data.FacturaEstado===1"
			:color="$colors.danger"
		>
			<fa-icon
				:icon="['fas','sad-tear']"
				class="mr-2"
			/>
			Impagada
			<a-icon
				v-if="actions"
				type="down"
			/>
		</a-tag>
		<a-tag
			v-else-if="data.FacturaEstado===2"
			:color="$colors.success"
		>
			<fa-icon
				:icon="['fas','check']"
				class="mr-2"
			/>
			Pagada
			<a-icon
				v-if="actions"
				type="down"
			/>
		</a-tag>
		<a-tag v-else>
			???
			<a-icon
				v-if="actions"
				type="down"
			/>
		</a-tag>

		<a-menu slot="overlay">
			<a-menu-item
				key="0"
				@click="setInvoiceStatus(0,'pendiente')"
			>
				<span class="text-warning">
					<fa-icon
						:icon="['fas','clock']"
						class="mr-2"
					/> Pendiente
				</span>
			</a-menu-item>
			<a-menu-item
				key="2"
				@click="setInvoiceStatus(2,'pagada')"
			>
				<span class="text-success">
					<fa-icon
						:icon="['fas','check']"
						class="mr-2"
					/> Pagada
				</span>
			</a-menu-item>
			<a-menu-item
				key="1"
				@click="setInvoiceStatus(1,'Impagada')"
			>
				<span class="text-danger">
					<fa-icon
						:icon="['fas','sad-tear']"
						class="mr-2"
					/> Impagada
				</span>
			</a-menu-item>
		</a-menu>
	</a-dropdown>
</template>

<script>
export default {
	name: 'InvoiceStatus',
	props: {
		data: {
			type: Object,
			required: true
		},
		actions: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		async setInvoiceStatus(value, text) {
			const result = await this.$gestios.items('facturas').edit({
				id: this.data._EntityId,
				params: {
					FacturaEstado: value
				}
			});

			if (result.ok) {
				this.$message.success(`La factura a cambiado a ${text}`);
			}
		}
	}
};
</script>

<style lang="scss" scoped>

</style>
